module.exports = __webpack_public_path__ + "img/0Q3A6078_L_BlackMatted.3fbc0161.jpg";